import React from "react";
import "./RoundedProgressBar.scss";

export default function RoundedProgressBar(props) {
    return(
        <div className={`d-flex flex-row p-0 m-0`}>
            <div className={`progress ${props.color}`}>
                <span className="progress-left">
                    <span className="progress-bar"></span>
                </span>
                <span className="progress-right">
                    <span className="progress-bar"></span>
                </span>
                <div className="progress-value">{props.value}</div>
            </div>
        </div>
    );
}